const Option = () => null;
Option.isSelectOption = true;
Option.displayName = 'OkkiSelectOption';
export default Option;
